var exports = {
  "n": "xa15a2ab7--5f1476--row",
  "H": "xa15a2ab7--5f1476--cell",
};

module.exports = exports;
